<template>
  <div>
    <div class="uk-grid-medium" uk-grid>
      <div class="uk-width-5-5">
        <div class="d-flex">
          <nav id="breadcrumbs" class="mb-3">
            <ul>
              <li>
                <a href="#"> <i class="uil-home-alt"></i> </a>
              </li>
              <li>{{ $t('general.ads_area_management') }}</li>
              <li>{{ $t('general.add_ads') }}</li>
            </ul>
          </nav>
        </div>

        <div class="card" v-if="is_loading">
          <default-loading></default-loading>
        </div>
        <template v-else>
      <template v-if="errorMessages">
          <div v-for="(error,index) in errorMessages" :key="index" class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:red;">
              <i class="uil-exclamation-triangle"></i> {{ error }} </p>
          </div>
          </template>
          <div v-if="successMessage" class="uk-alert-success" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p style="color:green;">
              <i class="uil-exclamation-triangle"></i> {{ successMessage }} </p>
          </div>
        <div class="card mt-4">
          <div class="card-body">
            <h4><i class="uil-question-circle"></i> {{ $t('general.add_ads') }}</h4>
            <hr />
            <div class="row">
              <div class="col-xl-9 m-auto">
                <form action="">
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="ad_title"
                      >{{ $t('general.heading') }}</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="ad_title"
                        name="title"
                        v-model="name"
                        :placeholder="$t('general.enter_title')"
                        required=""
                      />
                    </div>
                  </div>
                  <div class="form-group row mb-3 align-items-center">
                     <label class="col-md-3 col-form-label" for="ad_title"
                      >{{ $t('general.status') }} <span class="required">*</span></label
                    >
                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <input
                          id="status_id"
                          type="checkbox"
                          class="mb-0"
                          v-model="status_id"
                        />
                        <label class="ml-2 mb-0" style="line-height: 1em" for="status_id">{{
                          status_id ? $t("general.active") : $t("general.passive")
                        }}</label>
                      </div>
                    </div>
                     <label class="col-md-3 col-form-label" for="ad_title"
                      >{{ $t('general.open_in_new_tab') }} <span class="required">*</span></label
                    >
                    <div class="col-md-3">
                      <div class="d-flex align-items-center">
                        <input
                          id="is_new_tab"
                          type="checkbox"
                          class="mb-0"
                          v-model="is_new_tab"
                        />
                        <label class="ml-2 mb-0" style="line-height: 1em" for="is_new_tab">{{
                          is_new_tab ? $t("general.yes") : $t("general.no")
                        }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label
                      class="col-md-3 col-form-label"
                      for="short_description"
                      >{{ $t('general.description') }}</label
                    >
                    <div class="col-md-9">
                      <textarea
                        v-model="text"
                        id="short_description"
                        class="form-control"
                      ></textarea>
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="ad_title"
                      >{{ $t('general.connection') }}</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="ad_title"
                        name="title"
                        v-model="url"
                        placeholder="https://www.example.com"
                        required=""
                      />
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="ad_title"
                      >{{ $t('general.button_text') }}</label
                    >
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="ad_title"
                        name="title"
                        v-model="button_text"
                        :placeholder="$t('general.enter_button_text')"
                      />
                    </div>
                  </div>
                  <div class="form-group row mb-3">
                    <label class="col-md-3 col-form-label" for="point"
                      >{{ $t('general.ads_image') }} <span class="required">*</span></label
                    >
                    <div class="col-md-9">
                      <div uk-alert>
                        <a class="uk-alert-close" uk-close></a>
                        <h5><i class="uil-comment-info-alt"></i> {{ $t('general.information') }}</h5>
                        <p v-html="$t('general.catalog_cover_image_info', {
                          formats: '<b>.jpg, .png, .gif</b>',
                          dimensions: '<b>1920x410</b>'
                        })"></p>
                      </div>
                      <div class="uploadOuter">
                        <label for="uploadFile" class="btn btn-info"
                          ><i class="uil-upload"></i> {{ $t('general.upload') }}</label
                        >
                        <strong>{{ $t('general.or') }}</strong>
                        <span class="dragBox">
                          <i class="icon-feather-file-plus"></i>
                          {{ $t('general.doc_file_drag_drop') }}
                          <input
                            type="file"
                            accept="image/*"
                            draggable="true"
                            @dragover.prevent
                            @dragenter="drag"
                            @dragleave="drop"
                            id="uploadFile"
                            @change="dropped"
                          />
                        </span>
                      </div>
                    <div class="position-relative d-flex justify-center justify-content-center">
                      <img style="height: 190px; display:none" class="rounded img-fluid logoarea" alt="">
                    </div>
                    </div>
                  </div>
                  <div class="uk-card-footer float-right pb-0 pr-0">
                    <button
                      class="uk-button uk-button-primary small"
                      type="button"
                      @click="saveForm"
                    >
                      <i class="icon-feather-arrow-right"></i> {{$t('general.save')}}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/core/services";
import moment from "moment";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import module, {
  BASE_URL,
  MODULE_NAME,
  CREATE_ITEM,
  ERROR,
} from "@/core/services/store/advertisement.module";

export default {
  name: "AdvertisementAdd",
  components: { DefaultLoading },
  data() {
    return {
      is_loading: false,
      name:'',
      text:'',
      status_id:1,
      is_new_tab:1,
      photo_link:null,
      url: '',
      button_text:'',
      errorMessages:[],
      successMessage:null,
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, module);
  },
  computed: {
    error: {
      get() {
        return store.getters[MODULE_NAME + '/' + ERROR]
      },
      set(value) {
      }
    },
    },
  methods: {
    saveForm(){
      let form = this;
      let formData = new FormData()
      this.errorMessages = [];
      this.is_loading = true
       if (form.photo_link == null) {
        this.errorMessages.push(
          this.$t("content.required.photo_link")
        );
        this.scrollTop()
        this.is_loading = false
        return false;
      }

      formData.append('name',form.name)
      formData.append('text',form.text)
      formData.append('status_id',form.status_id == true ? 1 : 0)
      formData.append('is_new_tab',form.is_new_tab == true ? 1 : 0)
      formData.append('url',form.url)
      formData.append('button_text',form.button_text)
      formData.append('photo_link', form.photo_link)
      store.dispatch(MODULE_NAME + '/' + CREATE_ITEM, {
        url: BASE_URL,
        contents: formData
      }).then(() => {
          this.scrollTop();
          if (!this.error) {
          this.successMessage = this.$t('general.successfully_created')
            this.$router.push({ name: "company.advertisement.list" });
          }else this.errorMessages.push(this.error)
        this.is_loading = false
      })
    },
    dropped(event) {
      let file = event.target.files[0];
      if (!file) return false;
      if (!this.compareTypeCompatibality(file, "image/*")) {
        $("#uploadFile").val("");
        this.errorMessages.push(this.$t("general.invalid_file_type"));
        this.scrollTop()
        return false;
      }

      let reader = new FileReader();
      reader.onload = (e) => {
        let img = new Image();
        img.onload = () => {
        if (img.width > 1920 || img.height > 410) {
          this.photo_link = null; 
          $("#uploadFile").val("");
          this.errorMessages.push(this.$t("general.image_dimension_exceeded"));
          this.scrollTop();
          
          let imageHolder = $(".logoarea");
          imageHolder.css("display", 'none');
          imageHolder.attr("src", "");

        } else {
          this.photo_link = file;
          let blob = URL.createObjectURL(file);
          let imageHolder = $(".logoarea");
          imageHolder.attr("src", blob);
          imageHolder.css("display", 'block');
          this.drop(event);
          }
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    compareTypeCompatibality(file, acceptableType) {
     return acceptableType.includes(file.type) || acceptableType.includes(file.name.split('.').pop())
       || (acceptableType.split('/')[0] == file.type.split('/')[0] && file.type.split('/')[0].toLowerCase() != 'application')
    },
    validateURL(url){
     var res = url.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
        return (res !== null)
    },
    drag(event) {
      event.target.parentNode.className = "draging dragBox";
    },
    drop(event) {
      event.target.parentNode.className = "dragBox";
    },
    resetMessages(){
      this.successMessage = null
      this.errorMessages = []
    },
    scrollTop(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    },
  },
  mounted() {
  },
    watch: {
    successMessage: function (val) {
      this.debouncedResetValues();
    },
    errorMessages: function (val) {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
</style>